import { FormField, Text } from '@/_components';
import { CardContainer, FormMediaInput, ImageTextHeader, useMedia } from '@/_containers';
import { PageHeaderContainer } from '@/_containers/headers/page/page-header-container';
import type { InventoryUpdateSchema } from '@/_pages/settings/inventory-kits/shared/schemas/inventory';
import type { OnPartialUpdate } from '@/_schemas/types';

import { GenerateLabelButton } from './generate-label-button';

import { useInventoryFormContext } from '../../form-context';

export function Header({
  id,
  onPartialUpdate,
  isEditable,
  isInventoryParent,
}: {
  id: string;
  isProfilePage?: boolean;
  isPending: boolean;
  isEditable: boolean;
  isInventoryParent?: boolean;
  onPartialUpdate: OnPartialUpdate<InventoryUpdateSchema>;
}) {
  const form = useInventoryFormContext();
  const [name, primary_sku, inventory_category] = form.watch(['name', 'primary_sku', 'inventory_category']);
  const folder_path = `inventories/${id}`;
  const { onImageUpdate } = useMedia(onPartialUpdate);

  return (
    <CardContainer>
      <section className="flex items-center justify-between">
        <div className="text-c-card-muted text-xs font-semibold">SKU: {primary_sku || '—'}</div>
        {!isInventoryParent && (
          <div className="-ml-2 flex-0">
            <GenerateLabelButton id={`${id}`} />
          </div>
        )}
      </section>

      <PageHeaderContainer className="mt-4 mb-6">
        <ImageTextHeader
          imageSlot={
            <FormField
              control={form.control}
              name="logo"
              render={({ field: { ref: _, ...field } }) => (
                <div className="shrink-0 grow-0">
                  <FormMediaInput
                    {...field}
                    size="lg"
                    shape="square"
                    label=""
                    disabled={!isEditable}
                    folder_path={folder_path}
                    onImageStateChange={onImageUpdate}
                  />
                </div>
              )}
            />
          }
          primarySlot={name}
          secondarySlot={
            <Text as="small" className="text-c-card-muted mt-0.5 font-normal">
              Category: {inventory_category?.name ?? '—'}
            </Text>
          }
        />
      </PageHeaderContainer>
    </CardContainer>
  );
}
